// verantwortungErben.ts — T-6: Ein Kontakt, der aus einer Firma heraus neu
// angelegt wird (Verbindung in der Akte, neu eingetippter Gegenkontakt,
// Organigramm), übernimmt FO/BO der Firma. Der Server macht das Erben selbst
// (`POST /contact` mit `verantwortungVonKontaktId`, geprüft auf Mandant,
// Lesbarkeit und persönliche Kontakte) — hier wird nur die Referenz angehängt.
//
// Nur, wenn der Body keine eigene Verantwortung mitbringt: ausdrücklich
// gewählte FO/BO gewinnen immer, und ein persönlicher Kontakt erbt nie.

type Body = Record<string, unknown>;

const gesetzt = (v: unknown): boolean =>
  Array.isArray(v) ? v.length > 0 : typeof v === "string" ? v.trim() !== "" : v != null;

export function mitVerantwortungVon<T extends Body>(
  body: T,
  kontaktId: number | null | undefined,
): T & { verantwortungVonKontaktId?: number } {
  if (!Number.isInteger(kontaktId) || (kontaktId as number) <= 0) return body;
  if (body.persoenlich === true) return body;
  if (gesetzt(body.foUserId) || gesetzt(body.foUserIds) || gesetzt(body.boType)) return body;
  return { ...body, verantwortungVonKontaktId: kontaktId as number };
}
